// extracted by mini-css-extract-plugin
module.exports = {"inputgroupContainer":"InputGroup_inputgroupContainer__kj6pt"};